import { Model } from "@/core/magnet";

export default Model.extend({
  url: "templates",
});
